import { GET_PROJECT_CMS_API } from '../commons/constants';
import { ProjectTypes } from '../types';
import { PaginationResponseTypes } from '../types/response';
import { get } from './axios';

export const fetchProjectsCms = async (request: {
  keyword?: string;
  lang?: string;
}): Promise<PaginationResponseTypes<ProjectTypes[]>> => {
  let res: any;
  const { keyword } = request;
  try {
    res = await get(`${GET_PROJECT_CMS_API}?keyword=${keyword}`);
  } catch (e) {
    console.error(e);
    return null;
  }
  return res;
};
